import { render, staticRenderFns } from "./DocumentHandler.vue?vue&type=template&id=ed117110"
import script from "./DocumentHandler.vue?vue&type=script&lang=js"
export * from "./DocumentHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports